.b2{flex-wrap:wrap;}